if (!customElements.get('product-mobile-gallery')) {
  class ProductMobileGallery extends HTMLElement {
    constructor() {
      super();
      this.mainSwiper = null;
      this.modalSwiper = null;
      this.isInitialized = false;
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.handleGalleryClick = this.handleGalleryClick.bind(this);
      this.closeModal = this.closeModal.bind(this);
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize());
      } else {
        if (typeof Swiper !== 'undefined') {
          this.initialize();
        } else {
          setTimeout(() => {
            if (typeof Swiper !== 'undefined') {
              this.initialize();
            } else {
              console.warn('Swiper not found. Make sure swiper-bundle.min.js is loaded.');
            }
          }, 500);
        }
      }
    }

    initialize() {
      this.cleanupSwipers();

      this.initMainSwiper();
      this.initModalSwiper();

      this.addEventListeners();

      this.isInitialized = true;

      this.dispatchEvent(new CustomEvent('gallery:initialized', {
        bubbles: true,
        detail: { gallery: this }
      }));
    }

    cleanupSwipers() {
      if (this.mainSwiper) {
        if (!this.mainSwiper.destroyed) {
          this.mainSwiper.destroy(true, true);
        }
        this.mainSwiper = null;
      }

      if (this.modalSwiper) {
        if (!this.modalSwiper.destroyed) {
          this.modalSwiper.destroy(true, true);
        }
        this.modalSwiper = null;
      }
    }

    initMainSwiper() {
      const mainSwiperContainer = this.querySelector('.product__media-mobile');
      if (!mainSwiperContainer) return;

      this.mainSwiper = new Swiper(mainSwiperContainer, {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        navigation: {
          prevEl: '.swiper-button-prev--product-mobile-gallery',
          nextEl: '.swiper-button-next--product-mobile-gallery',
        },
        pagination: {
          el: '.product__media-mobile-pagination',
          type: 'bullets',
          clickable: true,
        },
        on: {
          afterInit: () => {
            this.updateGalleryImages();
          },
        },
      });
    }

    initModalSwiper() {
      const modalSwiperContainer = this.querySelector('.mobile-media-gallery__swiper');
      if (!modalSwiperContainer) return;

      this.modalSwiper = new Swiper(modalSwiperContainer, {
        loop: false,
        slidesPerView: '1',
        navigation: {
          nextEl: '.swiper-button-next--mobile-media-gallery',
          prevEl: '.swiper-button-prev--mobile-media-gallery',
        },
        on: {
          afterInit: () => {
            this.updateModalGalleryImages();
          },
          slideChange: (swiper) => {
            const prevSlide = swiper.slides[swiper.previousIndex];
            if (!prevSlide) return;
            const pinchToZoomContainer = prevSlide.querySelector('.pinch-zoom-container');
            if (pinchToZoomContainer) {
              pinchToZoomContainer.dispatchEvent(new Event('reset-zoom'));
            }
          }
        },
      });
    }

    updateGalleryImages() {
      if (!this.mainSwiper) return;

      this.mainSwiper.removeAllSlides();

      const currentColor = this.getCurrentColor();

      const slideHolders = this.querySelectorAll('.swiper__images-holder .swiper-slide-holder');

      slideHolders.forEach(holder => {
        const img = holder.querySelector('img');
        if (img && img.dataset.color && img.dataset.color === currentColor) {
          this.mainSwiper.appendSlide(holder.querySelector('.swiper-slide').cloneNode(true));
        }
      });

      this.mainSwiper.update();
    }

    updateModalGalleryImages() {
      if (!this.modalSwiper) return;

      this.modalSwiper.removeAllSlides();

      const currentColor = this.getCurrentColor();

      const slideHolders = this.querySelectorAll('.swiper__images-holder .swiper-slide-holder');

      slideHolders.forEach(holder => {
        const img = holder.querySelector('img');
        if (img && img.dataset.color && img.dataset.color === currentColor) {
          const image = img.cloneNode(true);
          image.classList.add('zoom-image', 'mobile-media-gallery__image');

          const pinchToZoomContainer = document.createElement('div');
          pinchToZoomContainer.classList.add('pinch-zoom-container');
          pinchToZoomContainer.appendChild(image);

          const swiperSlide = document.createElement('div');
          swiperSlide.classList.add('swiper-slide', 'mobile-media-gallery__swiper-slide');
          swiperSlide.appendChild(pinchToZoomContainer);

          this.modalSwiper.appendSlide(swiperSlide);

          this.initPinchToZoom(pinchToZoomContainer);
        }
      });

      this.modalSwiper.update();
    }

    getCurrentColor() {
      const closestProductFormSection = this.closest('section[id^="MainProduct-"]');
      const colorInput = closestProductFormSection.querySelector('.option--Color input:checked');
      if (colorInput) {
        return colorInput.value.toLowerCase().replaceAll(' ', '-').replaceAll('/', '-');
      }
      return '';
    }

    addEventListeners() {
      document.addEventListener('variantUpdated', this.handleVariantChange);

      const mainGalleryWrapper = this.querySelector('.product__media-mobile-swiper-wrapper');
      if (mainGalleryWrapper) {
        mainGalleryWrapper.addEventListener('click', this.handleGalleryClick);
      }

      const closeButton = this.querySelector('#ModalClose-ProductMobileMedia');
      if (closeButton) {
        closeButton.addEventListener('click', this.closeModal);
      }
    }

    handleVariantChange() {
      this.updateGalleryImages();
      this.updateModalGalleryImages();
    }

    handleGalleryClick(event) {
      if (window.innerWidth > 1099) return;
      const productMobileGalleryModal = this.querySelector('#ModalDrawer-ProductMobileMedia');
      if (productMobileGalleryModal && typeof productMobileGalleryModal.show === 'function') {
        productMobileGalleryModal.show();
      }
    }

    openModal() {
      const productMobileGalleryModal = this.querySelector('#ModalDrawer-ProductMobileMedia');
      if (productMobileGalleryModal && typeof productMobileGalleryModal.show === 'function') {
        productMobileGalleryModal.show();
      }
    }

    closeModal() {
      const productMobileGalleryModal = this.querySelector('#ModalDrawer-ProductMobileMedia');
      if (productMobileGalleryModal && typeof productMobileGalleryModal.hide === 'function') {
        productMobileGalleryModal.hide();
      }
    }

    initPinchToZoom(container) {
      const image = container.querySelector('.zoom-image');
      if (!image) return;

      // Track scale, translation, and initial gesture state
      let scale = 1;
      let currentX = 0;
      let currentY = 0;
      let disableTouchMove = false;

      // Will store data on gesture start
      let startDist = 0;
      let startScale = 1;
      let startX = 0;
      let startY = 0;
      let midpoint = { x: 0, y: 0 };

      // For double-tap detection
      let lastTapTime = 0;
      const doubleTapDelay = 300; // ms threshold for double tap

      // Helper: distance between two fingers
      const getDistance = (touches) => {
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      };

      // Helper: midpoint between two fingers
      const getMidpoint = (touches) => {
        return {
          x: (touches[0].clientX + touches[1].clientX) / 2,
          y: (touches[0].clientY + touches[1].clientY) / 2,
        };
      };

      // Set transform on the image
      const updateTransform = () => {
        image.style.transform = `translate(${currentX}px, ${currentY}px) scale(${scale})`;
      };

      // Reset to the original scale and position
      const resetToOriginal = () => {
        scale = 1;
        currentX = 0;
        currentY = 0;
        updateTransform();
      };

      // Handle touchstart
      container.addEventListener('touchstart', (e) => {
        if (e.touches.length === 1) {
          // Single finger start
          startX = e.touches[0].clientX - currentX;
          startY = e.touches[0].clientY - currentY;
        } else if (e.touches.length === 2) {
          // Two-finger pinch start
          startDist = getDistance(e.touches);
          midpoint = getMidpoint(e.touches);
          startScale = scale;
        }
      });

      // Handle touchmove
      container.addEventListener('touchmove', (e) => {
        e.preventDefault();

        if (disableTouchMove) return;

        if (e.touches.length === 1) {
          // Single finger => pan
          currentX = e.touches[0].clientX - startX;
          currentY = e.touches[0].clientY - startY;
        } else if (e.touches.length === 2) {
          // Two-finger => pinch
          const dist = getDistance(e.touches);
          scale = startScale * (dist / startDist);

          // If scale goes below 1, reset immediately:
          if (scale < 1) {
            resetToOriginal();
            return;
          }

          // Calculate new translation so the pinch "center" stays under fingers
          const newMidpoint = getMidpoint(e.touches);
          currentX += newMidpoint.x - midpoint.x;
          currentY += newMidpoint.y - midpoint.y;
          midpoint = newMidpoint;
        }

        updateTransform();
      });

      // TOUCH END + DOUBLE TAP DETECTION
      container.addEventListener('touchend', (e) => {
        // Restrict max zoom
        if (scale < 1 || scale == 1) {
          resetToOriginal();
          return;
        }

        if (scale > 4) scale = 4;

        // Disable touchmove for a short time after a single-touch event
        // Because when user pulls his one finger after pinch, it triggers touchmove event
        // Flicking the image
        if (e.touches.length === 1) {
          disableTouchMove = true;

          setTimeout(() => {
            disableTouchMove = false;
          }, 300);
        }

        // Detect double-tap (only relevant if it was a single-touch)
        if (e.changedTouches.length === 1 && e.touches.length === 0) {
          const now = Date.now();
          if (now - lastTapTime < doubleTapDelay) {
            // Double tap => reset
            resetToOriginal();
          }
          lastTapTime = now;
        }
      });

      container.addEventListener('reset-zoom', () => {
        resetToOriginal();
      });
    }

    refreshGallery() {
      this.updateGalleryImages();
      this.updateModalGalleryImages();
    }

    disconnectedCallback() {
      document.removeEventListener('variantUpdated', this.handleVariantChange);

      const mainGalleryWrapper = this.querySelector('.product__media-mobile-swiper-wrapper');
      if (mainGalleryWrapper) {
        mainGalleryWrapper.removeEventListener('click', this.handleGalleryClick);
      }

      const closeButton = this.querySelector('#ModalClose-ProductMobileMedia');
      if (closeButton) {
        closeButton.removeEventListener('click', this.closeModal);
      }

      this.cleanupSwipers();
    }
  }

  customElements.define('product-mobile-gallery', ProductMobileGallery);
}